/* 
	在下方导入弹窗文件
	import xxx from 'xxx.vue'
	
	在DIALOG数组中注册组件
	DIALOG = [
		xxx
	]
	
	任意页面调用弹窗
	this.globalDialog(name, opt, resolve, cancel)
	可传入以下参数
	name: 弹窗name，对应弹窗文件中的name属性
	opt: {  传入弹窗的数据，包含两部分
		props: {...},  弹窗内props属性定义的变量值
		data: {...}  传入弹窗内open方法的数据
	}
	resolve:  确认回调函数，在弹窗内调用this.$emit('resolve')触发
	cancel: 取消回调函数，在弹窗内调用this.$emit('cancel')触发
	
	
	例如：
	this.globalDialog('staffSelector', {
		props: {
			multiple: true
		},
		data: {
			id: 1
		}
	}, this.aaa, this.bbb)
	
	等价于
	
	<staff-selector ref="staffSelector" :multiple="true" @resolve="aaa" @cancel="bbb"></staff-selector>
	this.$refs.staffSelector.open({
		id: 1
	});
 */

import router from '@/router';
import store from '@/store';

// 批量编辑
import workFieldEdit from '@/components/view/work_field_edit.vue'
// 公式编辑器
import formulaEditor from "@/pages/custom/formula_edit.vue"
// 选择打印模板
import exportTemplateSelector from "@/components/service/export_template_selector.vue"
// 分享
import shareDialog from '@/components/service/share_dialog.vue'
// 选择产品
import productSelector from '@/components/service/product_selector.vue'
// 选择产品批次库存
import productBatchSelector from '@/components/service/product_batch_selector.vue'
// 选择订单产品
import orderProductSelector from '@/components/service/order_product_selector.vue'
// 创建产品
import productEdit from "@/pages/basic/product_edit.vue"
// 创建工序
import processEdit from "@/pages/basic/dic_process_edit.vue"
// 创建工艺路线
import processRouteEdit from '@/pages/basic/process_route_edit.vue'
// 系统业务日志
import workLogDetail from "@/pages/system/sys_work_logs_detail.vue"
// 导入Excel数据弹窗
import excelImport from "@/pages/system/import_excel_data.vue"
// 导入业务日志
import importLogDetail from "@/pages/system/import_work_logs_detail.vue"
// 模板管理
import templateManage from '@/components/service/template_manage.vue'
// 打印模板编辑
import printTemplateEdit from '@/components/service/print_template_edit.vue'
//选择绩效工资维度
import salaryDimensionSelector from '@/components/service/salary_dimension_selector.vue'
//选择出库单据信息（仓库、类型等）
import storageInfoSelector from '@/components/service/storage_info_selector.vue';
// 手机端视图配置
import appViewConfig from '@/components/service/app_view_config.vue'
import fieldConfig from '@/components/view/user_field_config.vue'
//配置用户自定义【工序】信息
import processConfig from '@/components/service/process_config.vue'
//配置用户自定义【不良品项】信息
import defectsConfig from '@/components/service/defects_config.vue'
//配置用户自定义【指标】信息
import indeicatorFieldConfig from '@/components/service/indeicator_field_config.vue'
//编辑供应商弹窗
import supplierEdit from '@/pages/basic/supplier_edit.vue';
//编辑客户弹窗
import customerEdit from "@/pages/basic/customer_edit.vue";

// 销售订单详情
import orderDetail from '@/pages/sales/order_detail.vue'
// 发货单
import orderDeliverEdit from '@/pages/sales/order_deliver_edit.vue'
import orderDeliverDetail from '@/pages/sales/order_deliver_detail.vue'
// 采购单
import purchaseOrderEdit from '@/pages/purchase/purchase_order_edit.vue'
import purchaseOrderDetail from '@/pages/purchase/purchase_order_detail.vue'
//批量生成工单
import batchWorkEdit from '@/pages/production/batch_work_edit.vue'
//生成装配工单
import assembleEdit from '@/pages/production/assemble_edit.vue'
// 生产计划
import planEdit from '@/pages/production/plan_edit.vue'
import planDetail from '@/pages/production/plan_detail.vue'
// 装配工单详情
import assembleDetail from '@/pages/production/assemble_detail.vue'
// 工单详情
import workDetail from '@/pages/production/work_detail.vue'
// 任务详情
import taskDetail from '@/pages/production/task_detail.vue'
// 分配人员
import taskAllot from '@/pages/production/task_allot.vue'
// 批量分配人员
import taskAllotBatch from '@/pages/production/task_allot_batch.vue'
// 新建报工
import outputEdit from '@/pages/production/output_edit.vue'
// 报工详情
import outputDetail from '@/pages/production/output_detail.vue'
// 新建委外单
import outSourcingEdit from '@/pages/supply/out_sourcing_order_edit.vue'
// 委外单详情
import outSourcingDetail from '@/pages/supply/out_sourcing_order_detail.vue'
// 入库单
import stockinDetail from '@/pages/storage/stockin_detail.vue'
// 出库单
import stockoutDetail from '@/pages/storage/stockout_detail.vue'
// 盘点单
import inventoryDetail from '@/pages/storage/inventory_detail.vue'
// 选择工单
import workSelector from '@/components/service/work_selector.vue'
// 生产入库检详情
import qualityWorkDetail from '@/pages/quality/quality_work_detail.vue'
// 不良品项
import defectsEdit from '@/pages/basic/dic_defects_edit.vue';

const DIALOG = [
	workFieldEdit,
	formulaEditor,
	productSelector,
	productBatchSelector,
	orderProductSelector,
	productEdit,
	processEdit,
	processRouteEdit,
	exportTemplateSelector,
	shareDialog,
	workLogDetail,
	excelImport,
	importLogDetail,
	templateManage,
	printTemplateEdit,
	appViewConfig,
	fieldConfig,
	salaryDimensionSelector,
	storageInfoSelector,
	processConfig,
	defectsConfig,
	indeicatorFieldConfig,
	supplierEdit,
	customerEdit,
	orderDetail,
	orderDeliverEdit,
	orderDeliverDetail,
	purchaseOrderEdit,
	purchaseOrderDetail,
	batchWorkEdit,
	assembleEdit,
	planEdit,
	planDetail,
	assembleDetail,
	workDetail,
	taskDetail,
	taskAllot,
	taskAllotBatch,
	outputEdit,
	outputDetail,
	outSourcingEdit,
	outSourcingDetail,
	stockinDetail,
	stockoutDetail,
	inventoryDetail,
	workSelector,
	qualityWorkDetail,
	defectsEdit
]
const DIALOG_CACHE = {};
let zIndex = 1011;

export default {
	install: function(Vue) {
		function compareObjects(obj1, obj2) {
			const keys1 = Object.keys(obj1);
			const keys2 = Object.keys(obj2);

			if (keys1.length !== keys2.length) {
				return false;
			}

			for (let key of keys1) {
				if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
					return false;
				}
			}
			return true;
		}
		
		Vue.prototype.globalDialog = function(name, opt = {}, resolve, cancel) {
			if (typeof opt == 'function') {
				cancel = resolve;
				resolve = opt;
				opt = {};
			}
			
			if (DIALOG_CACHE[name] && !compareObjects(opt.props || {}, DIALOG_CACHE[name].props || {})) {
				DIALOG_CACHE[name].vm.$destroy();
			}
			
			if (!DIALOG_CACHE[name]) {
				DIALOG_CACHE[name] = {props: opt.props};
				let comp = DIALOG.find(comp => comp.name == name);
				if (!comp) return;
				let constructor = Vue.extend(comp);
				DIALOG_CACHE[name].vm = new constructor({
					router,
					store,
					el: document.createElement('div'),
					propsData: opt.props,
					beforeDestroy() {
						delete DIALOG_CACHE[name];
						this.$el.remove();
					}
				});
				document.body.appendChild(DIALOG_CACHE[name].vm.$el);
				DIALOG_CACHE[name].vm.$el.style.position = 'relative';
			}
			
			DIALOG_CACHE[name].vm.$el.style.zIndex = zIndex++;
			DIALOG_CACHE[name].vm.open(opt.data);
			
			let events = {resolve, cancel};
			for (let event in events) {
				DIALOG_CACHE[name].vm.$off(event);
				events[event] && DIALOG_CACHE[name].vm.$on(event, (...params) => {
					events[event].apply(this, params);
				});
			}

			return DIALOG_CACHE[name].vm;
		}

		Vue.prototype.globalDialogDestroy = function() {
			for (let name in DIALOG_CACHE) {
				DIALOG_CACHE[name].vm.$destroy();
			}
		}
	}
}